import { Field } from 'module/api/field/types';
import {
  NumberFieldFilter,
  NumberFilterOperationType,
} from 'module/types/filter-field/filter/number';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { getFieldValue } from './get-field-value';

export const number = (filter: NumberFieldFilter): FilterFunction => {
  const value = getFieldValue<number>(filter.field as any as Field);

  switch (filter.type) {
    case NumberFilterOperationType.IsEmpty:
      return (record) => value(record) == null;
    case NumberFilterOperationType.IsNotEmpty:
      return (record) => value(record) != null;
    case NumberFilterOperationType.Is:
      return (record) => value(record) === filter.value;
    case NumberFilterOperationType.IsGreaterThan:
      return (record) => {
        const val = value(record);

        return val == null ? false : val > filter.value!;
      };
    case NumberFilterOperationType.IsLessThan:
      return (record) => {
        const val = value(record);

        return val == null ? false : val < filter.value!;
      };
    default:
      return () => true;
  }
};
